module.exports = __webpack_public_path__ + "img/EtiquetaFase3.599cef7f.png";